import * as React from "react";
import styled, { css } from "../../styled";
import { shadeAlternate } from "../..";
const TimelineWrapper = styled("div") `
  background: ${({ theme }) => shadeAlternate(0.03, theme.colors.background)};
  padding: 45px 54px 20px 54px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`;
const TimelineConnector = styled("div") `
  height: 3px;
  width: 100%;
  background: ${({ theme }) => shadeAlternate(0.2, theme.colors.background)};
  ${({ active }) => !active
    ? ""
    : css `
          background: ${({ theme }) => theme.colors.primary};
        `};
`;
const TimelineMarker = styled("div") `
  position: relative;
  height: 14px;
  width: 14px;
  min-width: 14px;
  border-radius: 50%;
  background: ${({ theme }) => shadeAlternate(0.2, theme.colors.background)};
  ${({ active }) => !active
    ? ""
    : css `
          background: ${({ theme }) => theme.colors.primary};
          .tl-label {
            display: none;
          }
        `};
  ${({ current }) => !current
    ? ""
    : css `
          .tl-label {
            display: block;
            font-weight: 600;
          }
        `};
`;
const TimelineMarkerLabel = styled("div") `
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  width: auto;
  white-space: nowrap;
`;
export class Timeline extends React.Component {
    render() {
        const { stages, current } = this.props;
        const currentIndex = stages.findIndex((s) => s.id === current);
        return (React.createElement(TimelineWrapper, null, stages.map((s, i) => {
            return [
                i === 0 ? null : (React.createElement(TimelineConnector, { key: `${i}-connector`, active: i <= currentIndex })),
                React.createElement(TimelineMarker, { key: `${i}-marker`, active: i <= currentIndex, current: i === currentIndex },
                    React.createElement(TimelineMarkerLabel, { className: "tl-label" }, s.label)),
            ];
        })));
    }
}
//# sourceMappingURL=index.js.map